import React from 'react';
import PrivacyMain from './PrivacyMain';

const Privacy = () => (
  <React.Fragment>
    <PrivacyMain />
  </React.Fragment>
);

export default Privacy;
